import {Pipe, PipeTransform} from '@angular/core';
import {BibResp, BibRespList} from '../models/bib-resp';

@Pipe({
    name: 'filterRespsByType'
})
export class FilterRespsByTypePipe implements PipeTransform {

    transform(resps: BibRespList, respTypes: Array<number>): any {
        if (!resps || !respTypes) {
            return resps;
        }
        return resps.filter(resp => respTypes.indexOf(resp.fkidbiblio_resp_types) !== -1);
    }

}



// WEBPACK FOOTER //
// ./src/app/pipes/filter-resps-by-type.pipe.ts